import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiMenu, FiX } from 'react-icons/fi';
import { FaXTwitter } from "react-icons/fa6";
import { FaTelegram } from "react-icons/fa";



import Logo from '../images/JackGloves.png'
import Clouds from '../images/clouds.png';


import OutbackJack from '../images/outbackjack.png'
import ChampionJack from '../images/championjack.webp'
import JackPunsh from '../images/JackPunsh.webp'
import OutbackJackBanner from '../images/HoldervsJeet.png'
import KillVirus from '../images/killvirus.webp'
import HappyJack from '../images/happyjack.webp'
import JackClap from '../images/JackClap.webp'
import Tokenomics from '../images/tokenomics.png'
function Main() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Effect hook to update the window width state on resize
  useEffect(() => {
      const handleResize = () => {
          setWindowWidth(window.innerWidth);
      };

      window.addEventListener('resize', handleResize);

      // Cleanup function to remove the event listener
      return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Determine the background size based on the window width
  const backgroundSize = windowWidth < 768 ? '80% 50%' : '100% 100%';

  const backgroundStyle = {
      backgroundImage: `url(${Clouds})`,
      backgroundSize: backgroundSize, // Conditionally set the size
      backgroundPosition: 'center',
    };
    
    const smoothScrollTo = (id) => {
      const section = document.querySelector(id);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    };


  const scrollToSection = (sectionId) => {
    smoothScrollTo(sectionId);
  };
  return (
    <>
    <div id="background-wrap">
    <div class="x1">
        <div class="cloud"></div>
    </div>

    <div class="x2">
        <div class="cloud"></div>
    </div>

    <div class="x3">
        <div class="cloud"></div>
    </div>

    <div class="x4">
        <div class="cloud"></div>
    </div>

    <div class="x5">
        <div class="cloud"></div>
    </div>
    
</div>
          <nav className="p-4 navfont  text-2xl BbbleFont">
            
        <div className="md:hidden">
          <button onClick={() => setIsOpen(!isOpen)} className="flex focus:outline-none">
            {isOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
        <div className="flex items-center justify-center">
          <img src={Logo} className='h-24 w-24 mr-10 flex justify-center' />
          <div className={`flex justify-center hidden md:block ${isOpen && windowWidth < 768 ? 'hidden' : 'flex'} space-x-9`}>
            <button onClick={() => scrollToSection('#about')} className="hover:text-gray-600">ABOUT</button>
            <button onClick={() => scrollToSection('#howtobuy')} className="hover:text-gray-600">HOW TO BUY</button>
            <button onClick={() => scrollToSection('#tokenomics')} className="hover:text-gray-600">TOKENOMICS</button>
          </div>
        </div>
        {isOpen && (
          <div className="md:hidden mt-4">
            <button onClick={() => scrollToSection('#about')} className="block py-2 px-4 hover:text-gray-600">ABOUT</button>
            <button onClick={() => scrollToSection('#howtobuy')} className="block py-2 px-4 hover:text-gray-600">HOW TO BUY</button>
            <button onClick={() => scrollToSection('#tokenomics')} className="block py-2 px-4 hover:text-gray-600">TOKENOMICS</button>
          </div>
        )}
      </nav>

    {/**WELCOME SECTION */}
    <div  className='rounded-div flex flex-col md:flex-col justify-center items-center text-blue-800 mt-20'>        
            <div className='flex flex-col justify-center items-center'>    
            <h1 className='text-6xl md:text-9xl BubbleFont'>Welcome to</h1>
            <h2 className='text-5xl md:text-7xl mt-2 BubbleFont'>Outback $JACK</h2>
            <h1 className='text-3xl mt-2 BubbleFont'>The sticker pack</h1>

            <img src={OutbackJack} alt="png" />
      
            <p className='text-center kidsfont text-black text-2xl w-96 mt-2'>Outback Jack is a sticker pack for Telegram! This is a set of 27 animated stickers. <br />He is a winner! </p>
            <div className='flex justify-between w-72 '>
            <Link to='https://tonviewer.com/EQDByR6xbRrTWIQFKfeBIjkIWLvnrlenGV97kiV3sEXRpT8E' target='_blank' className='BubbleFont flex m-auto justify-center p-1 border w-28 text-3xl mt-10 bg-red-600 rounded-2xl hover:bg-red-500 text-white shadow-2xl'>
                Contract
            </Link>
            <Link to='https://t.me/+L_GWkWCvUGljNzM0' className='flex items-center justify-center w-28 text-center text-3xl mt-10 rounded-2xl text-black'>
                <FaTelegram />
            </Link>
            <Link to='https://twitter.com/OutbackJack_TON' className='flex items-center justify-center w-28 text-center text-3xl mt-10 rounded-2xl text-black'>
                <FaXTwitter />
            </Link>
            </div>
            
            </div>
            <div className='ml-16'>

              <img src={OutbackJackBanner} alt="png" />
    
            </div>

        </div>


{/**ABOUT SECTION*/}
        <div id='about' className='rounded-div flex flex-col-reverse md:flex-row justify-start lg:justify-center items-center text-blue-800 mt-20'>
                <img src={JackPunsh} alt="img" className='h-56 md:h-56' />
        <div className='flex flex-col items-center'>
        <h1 className='BubbleFont text-2xl'>Why $JACK</h1>
        <p className='text-center w-96 kidsfont text-black'>
        Why Outback Jack? There's no doubt that TON meme season is coming, and it's all about sticker pack memes! We chose $JACK because he's based and widely used in groups!
Join us on our journey


</p>
        </div>    
        <img src={ChampionJack} alt="png" className='h-56 rounded-2xl ml-20 hidden xl:block'/>
        
    </div>



{/**HOW TO BUY SECTION */}
    <div id='howtobuy' className='rounded-div flex-col justicy-between mt-20 '>

        <h1 className='text-center BubbleFont text-6xl text-blue-800'>How to buy</h1>

        <div className='flex flex-col md:flex-row justify-between font-serif font-bold items-center w-full mt-12'>
        <div className='h-80 w-56 border border-2 border-pink-300 shadow-2xl p-2 rounded-xl mt-5 border border-pink-300'>
            <div><h1 className='BubbleFont text-3xl ml-2'>1. Download Tonkeeper</h1></div>
            <div className='p-3 bg-white shadow-2xl rounded-2xl'><p>Buy and bridge from any chain/exchange to your TON wallet</p></div>
            <img src={KillVirus} alt="png" />
        </div>

        <div className='h-80 w-56 border border-2 border-pink-300 shadow-2xl p-2 rounded-xl mt-5 border border-pink-300'>
        <div>
          <h1 className='BubbleFont text-3xl ml-2'>2. Bridge</h1>
          <img src={HappyJack} alt="png" />
        </div>
        <div className='p-5 shadow-2xl bg-white rounded-2xl'>
          <ul>
            <li className='border-b s'><Link to='https://sideshift.ai/eth/ton'>SideShift.ai</Link></li>    
          </ul>        
        </div>
        
        </div>

        <div className='h-80 w-56 border border-2 border-pink-300 shadow-2xl p-2 rounded-xl mt-5'>
        <div><h1 className='BubbleFont text-2xl ml-2'>3. Swap TON for $JACK on Dedust.io</h1></div>
        <div className='p-5 bg-white shadow-2xl rounded-2xl'><p>Welcome to the $JACK Community</p>
        <img src={JackClap} alt="png" />
        </div>
        
        </div>

        </div>
    </div>

 
{/**TOKENOMIS SECTION*/}
    <div id='tokenomics' className='flex flex-col justify-center items-center mt-10 md:mt-40'>
        <h1 className='BubbleFont text-blue-800 text-5xl md:text-7xl'>Tokenomics:</h1>

        <img src={Tokenomics} alt="png" className='h-52 md:h-96  rounded-2xl shadow-2xl' />
        
        <p className='text-center w-96 mt-4 kidsfont'>$JACK is a meme coin with no intrinsic value or expectation of financial return. There is no formal team or roadmap. the coin is completely useless and for entertainment purposes only.</p>
        </div>
    
    </>

    
  );
}

export default Main;
